define([
    "../hereMapsModule"
], function(hereMapsModule) {
    "use strict";

    return hereMapsModule.service("hereMapsConfigurationLoader",[
        "$q",
        "$http",
        "loadingService",
        "hereMapsConfiguration",
        "hereMapsConfigurationServiceUrl",
        function (
            $q,
            $http,
            loadingService,
            hereMapsConfiguration,
            hereMapsConfigurationServiceUrl ) {

        this.load = function () {
            if ( hereMapsConfiguration.hasApiKey() ) {
                return $q.resolve();
            }
            return loadingService( $http.get( hereMapsConfigurationServiceUrl.getUrl() ) )
                .then(function (response) {
                    var data = getData(response);
                    var config = {
                       apiKey: data.apiKey
                   };
                   hereMapsConfiguration.setConfig(data);

                   return config;
                });
        };
            function getData(response) {
                return response.data;
            }
    }]);
});